import React from 'react';

import HomeTitle from './home-title';
import HomeRecipes from './home-recipes';
import HomeContact from './home-contact';

function Home(){
  return (
    <div className="body-section">
      <HomeTitle />
      <HomeRecipes />
      <HomeContact />
    </div>
  )
}

export default Home;